/**
 * Product Swatches
 * @module productSwatches
 */

import $ from 'jquery';
import debounce from 'lodash/debounce';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
export const PLUGIN_NAME = 'productSwatches';

export const DEFAULTS = {
  productSwatch: '.product-swatches__swatch',
  viewMoreBtnBlock: '.js-toggle-block',
  viewMoreBtn: '.js-toggle-row',
  visibleRows: 2,
};

/**
 * Checks if the top of the last swatch is >= the height of the swatch
 * multiplied by the # of expected rows
 * @param  {jQuery} $el - product swatches element
 * @param  {jQuery} $lastSwatch - last swatch nested in the product swatches element
 * @return {Boolean}
 */
const lastSwatchIsHidden = ($el, $lastSwatch, opts) => {
  if($lastSwatch.position().top >= ($lastSwatch.outerHeight(true) * opts.visibleRows)) {
    return true;
  }
  return false;
};

/**
 * Toggle View More button
 * @param  {jQuery} $el - product swatches element
 * @param  {jQuery} $lastSwatch - last swatch nested in the product swatches element
 */
const toggleViewMore = ($el, $lastSwatch, opts) => {
  const { viewMoreBtn, viewMoreBtnBlock } = opts;
  if(lastSwatchIsHidden($el, $lastSwatch, opts)) {
    $el.next(viewMoreBtnBlock).find(viewMoreBtn).removeClass('u-hide');
  } else {
    $el.next(viewMoreBtnBlock).find(viewMoreBtn).addClass('u-hide');
  }
};

/**
 * Set Event Listener
 * @param  {jQuery} $el - header element
 * @param  {jQuery} $window - window element
 */
const setEventListener = ($el, $window, opts) => {
  const $lastSwatch = $el.find(opts.productSwatch).last();
  $window.on('resize.productSwatch', debounce(() => { toggleViewMore($el, $lastSwatch, opts); }, 100)).trigger('resize.productSwatch');
};


/**
 * Initializes product swatches
 * @param {HTMLElement} el - product swatches element
 * @see DEFAULTS
 */
export default function productSwatches(el, options = {}) {
  const $el = $(el);
  const $window = $(window);
  const opts = mergeOptions(DEFAULTS, options, $el);

  setEventListener($el, $window, opts);
}
registerJQueryPlugin(PLUGIN_NAME, productSwatches);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-swatches.js